import { makeRequest } from '../utils/apiUtils';

export const GET_CHANNELS = 'channels/GET_CHANNELS';
export const GET_CHANNELS_SUCCESS = 'channels/GET_CHANNELS_SUCCESS';
export const GET_CHANNELS_FAIL = 'channels/GET_CHANNELS_FAIL';

let channelsPromise = null;

export function getChannels() {
  return (dispatch, getState, extraArgument) => {
    const userId = getState().auth.user?.id;
    const isLoading = getState().channels.isLoading;

    if (isLoading) {
      return channelsPromise;
    }

    return channelsPromise = makeRequest(`/saduka/trafficChannels?is_active=true&webmaster_user_id=${userId ?? ''}&perpage=10000`, {
      types: [GET_CHANNELS, GET_CHANNELS_SUCCESS, GET_CHANNELS_FAIL],
      options: {
        credentials: 'include'
      },
    })(dispatch, getState, extraArgument);
  }
}
